import { api } from "@/shared/api/base";
import { LS_I18NEXT_LANG, PAGE_LOGIN } from "@/shared/constants";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useEffect } from "react";

export const language = () => localStorage.getItem(LS_I18NEXT_LANG) || "uz";

export const useApiQuery = <Data = any, Error = any>(
  url: string,
  params: object = {},
  options: Omit<UseQueryOptions<Data, Error>, "queryKey" | "queryFn"> & {
    toast?: boolean;
    onSuccess?: (data: Data) => void;
  } = {},
) => {
  const result = useQuery({
    queryKey: [url, params],
    queryFn: async () => {
      try {
        const response = await api.get<Data>(url, { params });
        return response;
      } catch (error: any) {
        if (error?.statusCode === 401) {
          window.location?.replace(PAGE_LOGIN);
          return error;
        }
        if (options.toast) {
          toast.error(
            error?.messages?.[language()] || error?.message || "Server error",
          );
        }
        return {
          data: [],
        };
      }
    },
    ...options,
  });
  useEffect(() => {
    if (result.status === "success" && result.data && options.onSuccess) {
      try {
        options.onSuccess(result.data);
      } catch (error) {
        console.error("Error in onSuccess callback:", error);
      }
    }
  }, [result.status, result.data, options.onSuccess]);

  return result;
};
